export default "__VITE_ASSET__F7GPw_y2__"